import { render, staticRenderFns } from "./LocationEventTypePage.vue?vue&type=template&id=2a046162"
import script from "./LocationEventTypePage.vue?vue&type=script&lang=js"
export * from "./LocationEventTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports